import React from 'react'
import {AdminPageHeadingArea} from '../pageBaseComponents/AdminPageHeadingArea'
import {HeadingAreaMessageComponent} from '../pageBaseComponents/HeadingAreaMessageComponent'
import SystemErrorHandler from '../pageBaseComponents/SystemErrorHandler'
import styled from 'styled-components'
import {RowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Paper} from '@mui/material'
import EventEmitterExAdmin from '../pageBaseComponents/EventEmitterExAdmin'
import {DisplaySizeValue} from '../../../styledComponents/Constants'
import {isMobile} from 'react-device-detect'
import {AppAdminContext} from '../../../app/AppAdminContext'
import {resetViewport, setViewportForPcPageOnSp} from '../../../common/util/ViewportUtils'
import {NavigateFunction} from 'react-router-dom'

interface ExternalProps {
    supportSp?: boolean
    headingAreaTitle?: string
    headingAreaDescription?: string
    isBeforeLoginPage?: boolean
    eventEmitter: EventEmitterExAdmin
    navigate: NavigateFunction
}

export interface AdminPageProps {
    eventEmitter: EventEmitterExAdmin
}

export const PageMainArea = styled(Paper)`
`

export const PageFooterArea = styled(RowFlexContainer)`
  padding-top: 10px;
  width: 100%;
  justify-content: space-between;
`

export const PageFotterAreaLeft = styled(RowFlexContainer)`
  justify-content: flex-start;
  flex-grow: 1;
  align-items: center;
  order: 1;
`
export const PageFotterAreaRight = styled(RowFlexContainer)`
  justify-content: flex-end;
  flex-grow: 1;
  align-items: center;
  order: 2;
`


export const withAdminPageTemplate = <OriginalProps extends {}>(
    AdminPageWrappedComponent: React.ComponentType<OriginalProps & AdminPageProps>,
) => {

    type ResultProps = OriginalProps & ExternalProps;


    const withAdminPageTemplateClass =
        class extends React.Component<ResultProps> {
            declare context: React.ContextType<typeof AppAdminContext>
            static displayName: string = `withAdminPageTemplate(${AdminPageWrappedComponent.displayName})`

            componentDidMount(): void {
                const supportSp: boolean = this.props.supportSp ?? false
                this.context.updateShowSpModePage(isMobile && supportSp)

                if (isMobile) {
                    if (supportSp) {
                        // スマホ対応画面の場合、viewportの設定を初期値に設定する
                        resetViewport()
                    } else {
                        // スマホ非対応画面（PC版のみ画面）の場合、デザイン崩れなく画面表示するためにviewportの横幅を1200pxに設定する
                        setViewportForPcPageOnSp()
                    }
                }
            }

            render(): JSX.Element {
                const {
                    headingAreaTitle,
                    headingAreaDescription,
                } = this.props

                return (
                    <>
                        <SystemErrorHandler
                            {...this.props}
                            url={'/admin/error'}
                            loginUrl={'/admin/login-portal'}
                        />
                        <MaxWidthContainer
                            $isBeforeLoginPage={this.props.isBeforeLoginPage}
                        >
                            {headingAreaTitle &&
                                <AdminPageHeadingArea
                                    title={headingAreaTitle}
                                    description={headingAreaDescription}
                                />
                            }
                            {!this.props.isBeforeLoginPage &&
                                <HeadingAreaMessageComponent
                                    {...this.props}
                                />
                            }
                            <AdminPageWrappedComponent
                                {...this.props}
                            />
                        </MaxWidthContainer>
                    </>
                )
            }
        }
    withAdminPageTemplateClass.contextType = AppAdminContext
    return withAdminPageTemplateClass
}

const MaxWidthContainer = styled.div<{ $isBeforeLoginPage?: boolean }>`
  max-width: ${props => props.$isBeforeLoginPage
          ? DisplaySizeValue.AdminWidthMin - (15 * 2)
          : DisplaySizeValue.AdminWidthMax}px;
  min-width: ${isMobile
          ? (DisplaySizeValue.ResidentWidthMin - (15 * 2))
          : (DisplaySizeValue.AdminWidthMin - (15 * 2))}px;
  width: 100%;
  margin: 0 auto;
`
